module.exports = __webpack_public_path__ + "media/images/flags/16/Norfolk-Island-c0a779439f2b974e508015b7824d8a37.png";